import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {MachineParkFilters} from "../model/filters/machine-park-filters";
import {HttpUtils} from "../shared/http.utils";
import {ConsumptionDataResponse} from '../model/responses/consumption-data-response';
import {ConsumptionFilters} from '../model/filters/consumption-filters';
import {AnalysisGeneralResponse} from "../model/responses/analysis-general-response";
import {FiltersUtils} from "../shared/filters.utils";

@Injectable({
  providedIn: 'root'
})
export class AnalysisService {

  private readonly analysisURL: string;


  constructor(private http: HttpClient) {
    this.analysisURL = '/api/analysis';
  }

  public getAnalysisGeneral(): Observable<{ analysisData: AnalysisGeneralResponse }> {
    return this.http.get<{ analysisData: AnalysisGeneralResponse }>(this.analysisURL);
  }

  public getMachineConsumption(filters?: ConsumptionFilters): Observable<ConsumptionDataResponse> {
    const url: string = `${this.analysisURL}` + "/consumption";
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams());
    if (filters != null) {
      options.params["alias"] = FiltersUtils.getFilterTrim(filters.alias);
      options.params["organizationUuids"] = FiltersUtils.getFilter(filters.organizationUuids);
      options.params["localities"] = FiltersUtils.getFilter(filters.localities);
      options.params["countries"] = FiltersUtils.getFilter(filters.countries);
      options.params["states"] = FiltersUtils.getFilter(filters.states);
      options.params["machineUuids"] = FiltersUtils.getFilter(filters.machineUuids);
      options.params["machineModelUuids"] = FiltersUtils.getFilter(filters.machineModelUuids);
      options.params["from"] = FiltersUtils.getFilter(filters.from);
      options.params["until"] = FiltersUtils.getFilter(filters.until);
    }
    return this.http.get<ConsumptionDataResponse>(url, options);
  }

  public getMachineParkData(filters?: MachineParkFilters): Observable<any> {
    const url: string = `${this.analysisURL}` + "/machinepark";
    let options = HttpUtils.buildOptions(HttpUtils.buildListParams());
    if (filters != null) {
      options.params["organizationUuids"] = FiltersUtils.getFilter(filters.organizationUuids);
    }
    return this.http.get<any>(url, options);
  }

}
